
import api from "../Api";
import { BaseService } from "../BaseService";

const URL = 'chats';

export class ChatsHistoryService extends BaseService {
    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async listMessages(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/messages/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async delete(id: number): Promise<any> {
        try {
            return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}